/* ===========================================================
   Site-level SEO configuration (single source of truth).

   Canonical URLs, sitemap and Open Graph tags all point at the real
   production domain (didiers.co.uk), regardless of which host currently
   serves the build. This means SEO equity always accrues to the correct
   domain — so when DNS cuts over from the preview subdomain, nothing has
   to change.

   Indexing is gated behind VITE_SEO_INDEX. While the site lives on the
   preview subdomain we HOLD indexing (robots noindex + Disallow) so Google
   never indexes the staging host. Flip VITE_SEO_INDEX=true at cutover.
   =========================================================== */

/** Canonical production domain — no trailing slash. */
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'https://didiers.co.uk').replace(/\/+$/, '');

/** Whether search engines may index this build. Default: false (hold). */
export const SEO_INDEX = String(import.meta.env.VITE_SEO_INDEX ?? '').toLowerCase() === 'true';

export const SITE_NAME = "Didier's Patisserie";

/** One-line B2B positioning reused across meta + JSON-LD. */
export const SITE_TAGLINE = 'Wholesale patisserie supplier for the UK food service industry';

export const SITE_DEFAULT_DESCRIPTION =
  'Premium French patisserie for restaurants, hotels and catering businesses. Trade accounts only — nationwide delivery from our London kitchen.';

/** Absolute default social-share image (1200x630). */
export const SITE_OG_IMAGE = `${SITE_URL}/assets/og-default.jpg`;

export const COMPANY = {
  legalName: "Didier's Patisserie",
  telephone: '+44 (0)208 293 3900',
  email: 'contact@didiers.co.uk',
  streetAddress: 'Unit 5, Cross Business Park, Salutation Road',
  addressLocality: 'Greenwich, London',
  postalCode: 'SE10 0AT',
  addressCountry: 'GB',
} as const;

/** Build an absolute canonical URL for a route path (e.g. "/about"). */
export function canonicalUrl(path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${clean === '/' ? '' : clean}`;
}
